// Normalize presentation only. Stored records, links, identifiers and text
// being edited are not rewritten. Portaled dialogs and asynchronous errors
// receive the same typography policy as ordinary React text.
export const visibleText = value => typeof value === 'string' ? value.replace(/\u2014/g, '-') : value
const ATTRIBUTES = ['title', 'aria-label', 'aria-description', 'aria-valuetext', 'placeholder', 'alt']
const excluded = element => element?.closest('script,style,noscript,textarea,input,[contenteditable]:not([contenteditable="false"])')

export function installVisibleTextPolicy (target = document.documentElement) {
  const textNode = node => {
    if (node.nodeType === 3 && !excluded(node.parentElement) && node.data.includes('\u2014')) node.data = visibleText(node.data)
  }
  const attributes = element => {
    for (const name of ATTRIBUTES) {
      const value = element.getAttribute(name)
      if (value?.includes('\u2014')) element.setAttribute(name, visibleText(value))
    }
  }
  const scan = node => {
    if (node.nodeType === 3) { textNode(node); return }
    if (node.nodeType !== 1) return
    attributes(node)
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT)
    while (walker.nextNode()) {
      if (walker.currentNode.nodeType === 1) attributes(walker.currentNode)
      else textNode(walker.currentNode)
    }
  }
  scan(target)
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') textNode(record.target)
      else if (record.type === 'attributes') attributes(record.target)
      else record.addedNodes.forEach(scan)
    }
  })
  observer.observe(target, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRIBUTES })
  return () => observer.disconnect()
}
